define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/def/Heading",
	"csi/util",
	"csi/xml"
], function(array, declare, Heading, util, xml) {

	return declare(null, {
		constructor(/*XMLNode?*/xn) {
			this._xn = xn;
			this.m_id = util.getProperty(xn, "Id");
			this.m_headings = util.getDefs(this._xn, "Heading", Heading) ?? [];

			// force headings in Card to be read-only unless otherwise configured
			this.m_headings.forEach((h) => {
				if (!h.getRight()) {
					h.setRight(xml.RIGHT_NONE);
				}
			});
		},

		resolve: function(lmap, rcRoot) {
			// FIX: at some point may need to use resolve function similar to view, but for now it is too much for our purposes here
			array.forEach(this.m_headings, function(h) {
				var rc = rcRoot && rcRoot.getPathClass(h.m_path);
				h.resolveHeading(lmap, null, rc);
			});
		},

		/**
		 * Parse card for any Card or Heading contents
		 * @return {Heading[]}
		 */
		parseCardsAndHeadings() {
			return util.getDefs(this._xn, "Card|Heading", Heading) ?? [];
		},

		getQueryPaths: function(rcRoot) {
			// summary: get all paths necessary for query
			// FIX: cannot use def.getQueryPaths because headings do not have data points
			var paths = [];
			var rc, rcr, path;

			array.forEach(this.m_headings, function(h) {
				rc = h.m_path ? rcRoot.getPathClass(h.m_path) : rcRoot;
				rcr = rc ? rc.getRelation(h.m_id, true, true) : null;
				path = rcr ? xml.pathAddStep(h.m_path, xml.PATH_OP_CHILD, h.m_id) : h.m_path;

				if (path && h.hasPathIndex()) {
					path = xml.pathAddStep(path, xml.PATH_OP_INDEX, h.m_index);
				}

				if (path) {
					paths.push(path);
				}
			});

			return paths;
		}
	});
});